module.exports = __webpack_public_path__ + "static/media/backgroundImage.5a969f3a.png";